import * as React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import { Facebook, Instagram, Twitter } from "@mui/icons-material";
import { Box } from "@mui/material";

export default function LayoutFooter() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: (theme) =>
          theme.palette.mode === "light"
            ? theme.palette.grey[200]
            : theme.palette.grey[800],
        p: 6,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={5}>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              About Us
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Know about Modern Public School is a Play School, Bilanderpur, Shahpura, Jaipur, is a Coed Day School.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Contact Us
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Near MPS CIRCLE, Bilanderpur, Shahpura, JAIPUR (RAJ.) 303803
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Email: info@mpsbilanderpur.com
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Phone: +1 234 567 8901
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Follow Us
            </Typography>
            <Link href="https://www.facebook.com/mpsbilanderpur" color="inherit">
              <Facebook />
            </Link>
            <Link
              href="https://www.instagram.com/mpsbilanderpur"
              color="inherit"
              sx={{ pl: 1, pr: 1 }}
            >
              <Instagram />
            </Link>
            <Link href="https://www.twitter.com/mpsbilanderpur" color="inherit">
              <Twitter />
            </Link>
          </Grid>
        </Grid>
        <Box mt={5}>
          <Typography variant="body2" color="text.secondary" align="center">
            {"Copyright "} &copy;
            <Link color="inherit" href="https://mpsbilanderpur.com/">
             Modern Public School
            </Link>{" "}
            {new Date().getFullYear()}
			
            {"."}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}